/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_OfflineInputs */



/**
* | output |
* | --- |
* | "Offline" |
*
* @param {Status_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const status_offline = /** @type {((inputs?: Status_OfflineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_OfflineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hors ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin conexión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Offline")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offline")
	return /** @type {LocalizedString} */ ("Offline")
});